<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="1200">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            Listagem de Formações
          </div>
        </v-toolbar>
        <div class="container dialog mt-4">
          <h3>
            Listagem de Formações
          </h3>
          <v-row class="justify-center">
            <v-data-table
                class="mt-5"
                :headers="headers"
                :items="lists.formacoes"
                :items-per-page="10"
                :footer-props="$footerProps"
                show-expand
                style="min-width: 900px;"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-4" v-if="item.escolas?.length > 0">
                  <v-simple-table dense>
                    <tbody>
                    <tr v-for="(escola, i) in item.escolas" :key="i">
                      <td>{{ escola.nome }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-row>
        </div>
        <v-row class="pl-8 pr-8 mt-n4">
          <v-col cols="12">
            <p class="formacao-info">Quantidade de Formações: {{ lists.formacoes?.length || 0 }}</p>
            <p class="formacao-info">Total de Carga Horária: {{ totalCargaHoraria }}h</p>
          </v-col>
        </v-row>
        <v-row  class="d-flex justify-center mt-4 mb-4" style="gap:2rem;">
          <v-btn outlined color="primary" @click="$emit('onClose')">Voltar</v-btn>
          <v-btn color="primary" class="mr-3" @click="baixarRelatorioPdf" >Exportar</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";

export default {
  props: new DialogProps(Dashboard),
  mixins: [DashboardFormacaoService],
  data: () => ({
    lists: {
      formacoes: [],
    },
    headers: [
      { text: "Formação", align: "center", value: "formacao" },
      { text: "Data de Realização", align: "center", value: "dataRealizacaoStr" },
      { text: "Carga Horária", align: "center", value: "cargaHoraria" },
      { text: "Escola", align: "center", value: "data-table-expand" },
    ],
  }),
  computed: {
    totalCargaHoraria() {
      return this.lists.formacoes.reduce((total, item) => {
        const valorNumerico = parseFloat((item.cargaHoraria || "0").replace(",", ".").replace("h", ""));
        return total + (isNaN(valorNumerico) ? 0 : valorNumerico);
      }, 0).toFixed(1).replace(".", ",");
    },
  },
  methods: {
    getFormacoes() {
      this.$buscarDashboardListaFormacoes({ params: {GreCodigo: this.content.id, OrigemId: this.content?.origemId}}).then(
          ({ data }) => this.lists.formacoes= data.lista
      )
    },
    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardListaFormacoesPdf(this.$montarParamsFilters(
            {GreCodigo: this.content.id, OrigemId: this.content?.origemId}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.ListagemDeFormações.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  mounted() {
    this.getFormacoes();
  },
}
</script>